<div *ngFor="let link of values(filterDashboardItemLinks)">
    <!-- TODO Obsłużyć pozostałe typy -->
    <app-category-filter-dashboard-item
        *ngIf="
            link.dashboardItemFactory.componentClass ==
            'CategoryFilterDashboardItem'
        "
        [dashboardItemFactory]="link.dashboardItemFactory"
        [dataLoaderEmitter]="link.dataLoaderEmitter"
    >
    </app-category-filter-dashboard-item>
    <app-date-picker
        *ngIf="
            link.dashboardItemFactory.componentClass ==
            'DateRangeFilterDashboardItem'
        "
        [dashboardItemFactory]="link.dashboardItemFactory"
        [dataLoaderEmitter]="link.dataLoaderEmitter"
    >
        ></app-date-picker
    >
    <app-segment-filter
        *ngIf="
            link.dashboardItemFactory.componentClass ==
            'SegmentsFilterDashboardItem'
        "
        [dashboardItemFactory]="link.dashboardItemFactory"
        [dataLoaderEmitter]="link.dataLoaderEmitter"
    ></app-segment-filter>
    <app-string-input-filter
        *ngIf="
            link.dashboardItemFactory.componentClass ==
            'StringInputFilterDashboardItem'
        "
        [dashboardItemFactory]="link.dashboardItemFactory"
    >
    </app-string-input-filter>
</div>
